import React, { Ref } from 'react'

import Select, { SelectProps } from 'components/ui/Select/Select'

const LinkStatusSelect = React.forwardRef(
  (props: SelectProps, ref: Ref<HTMLInputElement>): JSX.Element => {
    const options = [
      { value: 'unlinkable', text: 'Unlinkable' },
      { value: 'unlinked', text: 'Unlinked' },
      { value: 'linked', text: 'Linked' },
      { value: 'user_disconnected', text: 'User Disconnected' }
    ]

    return (
      <div className="relative rounded-md shadow-sm w-full">
        <Select options={options} {...props} ref={ref} />
      </div>
    )
  }
)

export default LinkStatusSelect
